
import { motion } from "framer-motion";
function Clients() {
  const fadeUpVariant = {
    hidden: { opacity: 0, y: 40 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.1, duration: 0.4, ease: "easeOut" },
    }),
  };
  const styles = {
    wrapper: {
      padding: '2rem',
      textAlign: 'center',
    },
    heading: {
      marginBottom: '1rem',
    },
    logoContainer: {
      display: 'flex',
      justifyContent: 'center',
      gap: '2rem',
      flexWrap: 'wrap',
    },
    logoImage: {
      maxWidth: '150px',
      maxHeight: '150px',
      objectFit: 'contain',
    },
    spancol:{
        color: '#fdb813', // Change this to your desired color
    }
  };
  const logos = [
    { src: 'naturals.png', alt: 'Naturals' },
    { src: 'easa.png', alt: 'Easa' },
    { src: 'thread.png', alt: 'Thread Stories' },
    { src: 'achoos.png', alt: 'Achoos' },
    { src: 'adsyuga.png', alt: 'Adsyuga' },
    { src: 'promise.png', alt: 'Promise' },
    { src: 'buildedgesolutions.png', alt: 'BuildEdge Solutions' },
    { src: 'careerguidance.png', alt: 'Career Guidance' },
  ];  

  return(
    <section id="clients" style={styles.wrapper}>
      <h1 style={styles.heading}><span style={styles.spancol}>Our</span> Clients</h1>
      <br/>
      <div style={styles.logoContainer}>
        {logos.map((logo, index) => (
          <motion.img
            key={index}
            src={require(`../media/clients/${logo.src}`)}
            alt={logo.alt}
            variants={fadeUpVariant}
            initial="hidden"
            whileInView="visible"
            custom={index}
            style={styles.logoImage}
          />
        ))}
      </div>
    </section>
  )
}

export default Clients;